export default {
      id: "icon-coeur-multiple-usage",
      viewBox: "0 0 221.5 61.8",
      url: __webpack_public_path__ + "icons.svg#icon-coeur-multiple",
      toString: function () {
        return this.url;
      }
    }